export const tmd = {
    agencyCode: '401',
    name: 'Texas Military Department',
    shortName: 'TMD',
    slug: 'tmd'
    
    
  };